import * as React from 'react';
import { DatePicker } from 'antd';
import { DateTime } from 'luxon';

import { luxonToMoment, momentToLuxon } from 'core/utils/zoomTime';

const { RangePicker } = DatePicker;

export type ZoomDateRange = [DateTime, DateTime] | null;

interface IZoomDateRangeFilterProps {
  value: ZoomDateRange;
  onChange: (range: ZoomDateRange) => void;
  disabled?: boolean;
}

/** Date-range filter bound to luxon DateTime (Europe/Warsaw). */
export const ZoomDateRangeFilter = ({
  value,
  onChange,
  disabled,
}: IZoomDateRangeFilterProps) => (
  <RangePicker
    disabled={disabled}
    format="YYYY-MM-DD"
    value={value ? [luxonToMoment(value[0]), luxonToMoment(value[1])] : null}
    onChange={(range) => {
      if (!range || !range[0] || !range[1]) {
        onChange(null);
        return;
      }

      const from = momentToLuxon(range[0]);
      const to = momentToLuxon(range[1]);

      if (from && to) {
        onChange([from, to]);
      }
    }}
  />
);
